import { Typography } from "@mui/material";
import { styled } from "@mui/system";

export const Heading1 = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "16px",
  fontWeight: 700,
  padding: "10px 0px",
}));

export const Heading2 = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "14px",
  fontWeight: 600,
  padding: "0px 0px",
}));

export const Heading3 = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "20px",
  fontWeight: 700,
  padding: "0px 0px",
}));

export const Text1 = styled(Typography)(() => ({
  fontFamily: "Source Sans Pro",
  fontSize: "16px",
  fontWeight: 400,
  padding: "0px 0px",
}));

export const Text2 = styled(Typography)(() => ({
  fontFamily: "Source Sans Pro",
  fontSize: "14px",
  fontWeight: 400,
  padding: "0px 0px",
}));

export const Text3 = styled(Typography)(() => ({
  fontFamily: "Source Sans Pro",
  fontSize: "12px",
  fontWeight: 600,
  padding: "0px 0px",
}));

export const Text4 = styled(Typography)(() => ({
  fontFamily: "Source Sans Pro",
  fontSize: "14px",
  fontWeight: 300,
  padding: "0px 0px",
}));
